import { RequestContext } from "@robe/core";
import { createContext } from "react";

export interface RequestContextEvents {
  onError?: (reason: unknown) => unknown;
}

export const ReactRequestContext = createContext<RequestContext & RequestContextEvents>(null!);

export const RequestContextProvider = ReactRequestContext.Provider;
